export default "__VITE_ASSET__C9eBFwv1__"